import { render, staticRenderFns } from "./IconForward.vue?vue&type=template&id=73574dd8&"
import script from "./IconForward.vue?vue&type=script&lang=ts&"
export * from "./IconForward.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports